import { TARGET_ID } from "./TargetId";

export const analyticsEvent = {
  [TARGET_ID.SUPPORT_BUTTON]: "spenmo support clicked",
  [TARGET_ID.FAQ]: "spenmo support faq clicked",
  [TARGET_ID.SEND_MESSAGE]: "spenmo support send message clicked",
};
